export default __webpack_public_path__ + "static/media/image-1.9536b262.png";